import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import BlogNews from "@/pages/BlogNews";

export const Route = createFileRoute("/blog-news")({
  head: () => seoHead({
    title: "Blog | Shopping do Bem",
    description: "Dicas, cupons e novidades sobre compras online solidárias.",
    path: "/blog-news",
  }),
  component: BlogNews,
});
